export default{
    spareParts:'备品备件',
    auxiliaries:'辅助设备',
	materialCode:'物料编码',
	sparePartsName:'备品备件名称',
	stockNumber:'库存数量(个)',
	stockPrice:'库存单价(元)',
	stockCost:'库存成本(数量*单价)',
	stockLocation:'库存地点',
	toolingNumber:'工装编号',
    deviceName:'设备名称',
	project:'所属项目',
	number:'数量(个)',
	usefulLife:'使用年限(开始-结束)',
	purpose:'用途',
    add:'新增',
    sparePartsEditSuccess: '修改成功',
    sparePartsAdd:'备品备件-新增',
    sparePartsEdit:'备品备件-编辑',
    sparePartsDelete:'备品备件-删除',
    auxiliariesAdd:'辅助设备-新增',
    auxiliariesEdit:'辅助设备-编辑',
    auxiliariesDelete:'辅助设备-删除',
    operation:'操作',
}



// WEBPACK FOOTER //
// ./src/config/i18n/zh-cn/sparePartsManagement.js